import { createSlice } from '@reduxjs/toolkit'

import { SLICES } from '@/reducers/utils/constants'

import { extraReducers, reducers } from './reducers'

const initialState = {
  stripeV2Enabled: false
}

const featureFlags = createSlice({
  extraReducers,
  initialState,
  name: SLICES.featureFlags,
  reducers
})

export const { actions } = featureFlags
export default featureFlags
